(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-lister"] && !Shopify.designMode) return;
  try {
    
  class VpBlogLister extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      this.footer = this.querySelector('[data-footer]');
      this.sectionId = this.dataset.sectionId;
      this.bindEvents();
    }

    bindEvents() {
      this.loadMoreButton = this.querySelector('.blog-lister__load-more');
      if (!this.loadMoreButton) return;
      this.loadMoreButton.addEventListener('click', this.onLoadMoreClick);
    }

    onLoadMoreClick = async () => {
      if (this.classList.contains('is-loading') || !this.loadMoreButton || !this.sectionId) return;

      const nextPage = this.footer?.dataset.nextPage;
      if (!nextPage) return;

      this.classList.add('is-loading');

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', nextPage);
        url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) throw new Error('Unable to load more blog posts.');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const nextSection = doc.querySelector(`blog-lister[data-section-id="${this.sectionId}"]`);
        const nextGrid = nextSection?.querySelector('[data-grid]');
        const nextFooter = nextSection?.querySelector('[data-footer]');
        if (!nextGrid || !nextFooter || !this.grid || !this.footer) return;

        const newCards = nextGrid.querySelectorAll('.blog-lister__card');
        newCards.forEach((card) => this.grid.append(card));
        this.footer.innerHTML = nextFooter.innerHTML;

        this.loadMoreButton = this.querySelector('.blog-lister__load-more');
        this.bindEvents();
      } catch (error) {
        // Keep current UI state and allow retry when loading fails.
      } finally {
        this.classList.remove('is-loading');
      }
    };
  }

  if (!customElements.get('blog-lister')) {
    customElements.define('blog-lister', VpBlogLister);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-shortcuts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBrandShortcutsVideos = (root = document) => {
      root.querySelectorAll('.brand-shortcuts__card').forEach((card) => {
        if (card.dataset.videoBound === 'true') return;

        const video = card.querySelector('.brand-shortcuts__media video');
        if (!video) return;

        const resetToFirstFrame = () => {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (error) {}
        };

        card.addEventListener('mouseenter', () => {
          try {
            video.currentTime = 0;
          } catch (error) {}
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });

        card.addEventListener('mouseleave', resetToFirstFrame);
        video.addEventListener('ended', resetToFirstFrame);

        resetToFirstFrame();
        card.dataset.videoBound = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBrandShortcutsVideos());
    } else {
      initBrandShortcutsVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initBrandShortcutsVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHistoryBackLinks = (root = document) => {
      root.querySelectorAll('[data-vp-history-back]').forEach((link) => {
        if (link.dataset.historyBackBound === 'true') return;

        link.addEventListener('click', (event) => {
          if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            !document.referrer
          ) {
            return;
          }

          let referrer;
          try {
            referrer = new URL(document.referrer);
          } catch (error) {
            return;
          }

          if (referrer.origin !== window.location.origin) return;

          event.preventDefault();
          window.history.back();
        });

        link.dataset.historyBackBound = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHistoryBackLinks(), { once: true });
    } else {
      initHistoryBackLinks();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initHistoryBackLinks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-overview"] && !Shopify.designMode) return;
  try {
    
  /**
   * Cart overview quantity steppers.
   *
   * With cart_type=drawer, bare /cart/change links are intercepted and open
   * Horizon's cart drawer. Always update via /cart/change.js and stay on /cart.
   */
  (() => {
    if (window.__vpCartOverviewBound) return;
    window.__vpCartOverviewBound = true;

    /** @type {AbortController | null} */
    let request = null;

    /**
     * @param {HTMLElement} root
     * @param {string} key
     * @param {number} quantity
     * @param {HTMLElement} [sourceEl]
     */
    async function changeLine(root, key, quantity, sourceEl) {
      request?.abort();
      request = new AbortController();
      root.setAttribute('aria-busy', 'true');

      if (sourceEl instanceof HTMLElement) {
        sourceEl.setAttribute('aria-busy', 'true');
      }

      try {
        const changeUrl = window.Theme?.routes?.cart_change_url;
        const response = await fetch(changeUrl ? `${changeUrl}.js` : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
          signal: request.signal,
        });

        if (!response.ok) {
          root.removeAttribute('aria-busy');
          sourceEl?.removeAttribute('aria-busy');
          return;
        }

        // Full reload keeps totals / Hitster gifts / badges in sync without
        // emitting cart events that would open a drawer/flyout.
        window.location.reload();
      } catch (error) {
        if (error?.name === 'AbortError') return;
        root.removeAttribute('aria-busy');
        sourceEl?.removeAttribute('aria-busy');
      }
    }

    // Document delegation survives section morph after discount apply/remove.
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const control = target.closest('[data-vp-cart-overview-change]');
        if (!(control instanceof HTMLElement)) return;

        const root = control.closest('[data-vp-cart-overview]');
        if (!(root instanceof HTMLElement)) return;

        const key = control.dataset.key;
        const quantity = Number.parseInt(control.dataset.quantity || '', 10);
        if (!key || Number.isNaN(quantity)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        changeLine(root, key, quantity, control);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-highlight"] && !Shopify.designMode) return;
  try {
    
  class CollectionHighlightCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.bar = this.querySelector('[data-progress-bar]');
      if (!this.track || !this.bar) return;

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.updateProgress();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      if (this.rafId != null) cancelAnimationFrame(this.rafId);
    }

    onScroll = () => {
      if (this.rafId != null) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this.updateProgress();
      });
    };

    updateProgress() {
      if (!this.track || !this.bar) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      this.classList.toggle('is-scrollable', maxScroll > 4);

      // Starts at the visible fraction (~25% for 4 cards) and fills to 100% at the end
      const progress = scrollWidth > 0 ? Math.min(1, (scrollLeft + clientWidth) / scrollWidth) : 1;
      this.bar.style.width = `${progress * 100}%`;
    }
  }

  if (!customElements.get('collection-highlight-carousel')) {
    customElements.define('collection-highlight-carousel', CollectionHighlightCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.faq__item'));
      if (!this.items.length) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.gsap = window.gsap || null;

      if (!this.gsap || this.reducedMotion) return;

      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.items.forEach((item) => this.initItem(item));
    }

    disconnectedCallback() {
      if (!this.items?.length) return;
      this.items.forEach((item) => {
        const summary = item.querySelector('.faq__summary');
        if (summary) {
          summary.removeEventListener('click', this.onSummaryClick);
        }
      });
    }

    initItem(item) {
      const summary = item.querySelector('.faq__summary');
      const answer = item.querySelector('.faq__answer');
      const icon = item.querySelector('.faq__icon');
      if (!summary || !answer) return;

      item.classList.add('is-gsap-ready');
      item._faqAnswer = answer;
      item._faqIcon = icon;
      item._faqTween = null;

      if (item.open) {
        this.gsap.set(answer, { height: 'auto', opacity: 1, overflow: 'hidden' });
      } else {
        this.gsap.set(answer, { height: 0, opacity: 0, overflow: 'hidden' });
        if (icon) this.gsap.set(icon, { rotate: 0 });
      }

      summary.addEventListener('click', this.onSummaryClick);
    }

    onSummaryClick(event) {
      event.preventDefault();
      const item = event.currentTarget.closest('.faq__item');
      if (!item || !item._faqAnswer) return;

      if (item.open) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      const answer = item._faqAnswer;
      const icon = item._faqIcon;
      item._faqTween?.kill?.();

      item.open = true;
      this.gsap.set(answer, { height: 0, opacity: 0, overflow: 'hidden' });
      const targetHeight = answer.scrollHeight;

      item._faqTween = this.gsap.timeline({
        defaults: { overwrite: true },
        onComplete: () => {
          this.gsap.set(answer, { height: 'auto' });
          item._faqTween = null;
        },
      });

      item._faqTween.to(answer, {
        height: targetHeight,
        opacity: 1,
        duration: 0.34,
        ease: 'power2.out',
      });

      if (icon) {
        item._faqTween.to(
          icon,
          {
            rotate: 180,
            duration: 0.34,
            ease: 'power2.out',
          },
          0
        );
      }
    }

    closeItem(item) {
      const answer = item._faqAnswer;
      const icon = item._faqIcon;
      item._faqTween?.kill?.();

      const startHeight = answer.offsetHeight;
      this.gsap.set(answer, { height: startHeight, overflow: 'hidden' });

      item._faqTween = this.gsap.timeline({
        defaults: { overwrite: true },
        onComplete: () => {
          item.open = false;
          item._faqTween = null;
        },
      });

      item._faqTween.to(answer, {
        height: 0,
        opacity: 0,
        duration: 0.28,
        ease: 'power2.inOut',
      });

      if (icon) {
        item._faqTween.to(
          icon,
          {
            rotate: 0,
            duration: 0.28,
            ease: 'power2.inOut',
          },
          0
        );
      }
    }
  }

  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lister"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  class RelatedArticlesCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.nextButton = this.querySelector('[data-next]');

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollNext());
      }

      this.updateNextVisibility();
      this.track?.addEventListener('scroll', () => this.updateNextVisibility(), { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
      this.updateNextVisibility();
    };

    scrollNext() {
      if (!this.track) return;

      const slide = this.track.querySelector('.related-articles__slide');
      if (!slide) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      this.track.scrollBy({ left: slide.getBoundingClientRect().width + gap, behavior: 'smooth' });
    }

    updateNextVisibility() {
      if (!this.track || !this.nextButton) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const canScroll = maxScroll > 4;
      const atEnd = this.track.scrollLeft >= maxScroll - 4;

      this.nextButton.hidden = !canScroll || atEnd;
    }
  }

  if (!customElements.get('related-articles-carousel')) {
    customElements.define('related-articles-carousel', RelatedArticlesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-highlights"] && !Shopify.designMode) return;
  try {
    
  class ReviewHighlights extends HTMLElement {
    static EXPANDED_GROW = 3;
    static COLLAPSED_GROW = 1;
    static DURATION = 0.28;
    static FADE_DURATION = 0.16;

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.track = this.querySelector('[data-track]');
      this.carousel = this.querySelector('[data-carousel]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.boundOnYotpoReviews = this.onYotpoReviewsLoaded.bind(this);

      this.addEventListener('vp:yotpo-reviews-loaded', this.boundOnYotpoReviews);

      if (!this.track) return;
      if (this.cards.length === 0 && this.querySelector('[data-vp-yotpo-carousel]')) return;

      this.initCarousel();
    }

    disconnectedCallback() {
      this.removeEventListener('vp:yotpo-reviews-loaded', this.boundOnYotpoReviews);
      if (this.mq) this.mq.removeEventListener('change', this.boundOnMedia);
      window.removeEventListener('resize', this.boundOnResize);
      this.track?.removeEventListener('scroll', this.boundOnScroll);
      this.track?.removeEventListener('scrollend', this.boundOnScrollEnd);
      if (this.timeline) this.timeline.kill();
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      if (this.scrollRafId != null) cancelAnimationFrame(this.scrollRafId);
    }

    onYotpoReviewsLoaded(event) {
      const sectionId = this.getAttribute('data-section-id');
      if (event.detail?.sectionId && event.detail.sectionId !== sectionId) return;
      this.refreshCards();
    }

    refreshCards() {
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      if (this.cards.length === 0 || !this.track) return;

      this.activeIndex = Number.parseInt(this.dataset.defaultActive || '0', 10);
      if (Number.isNaN(this.activeIndex) || this.activeIndex < 0) this.activeIndex = 0;
      if (this.activeIndex >= this.cards.length) {
        this.activeIndex = Math.floor(this.cards.length / 2);
      }

      if (!this.mq) {
        this.initCarousel();
        return;
      }

      this.bindCardEvents();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.ensureGsap().then(() => {
            if (!this.isConnected) return;
            this.applyLayout(true);
            this.updateMobilePaging();
            this.updateProgress();
          });
        });
      });
    }

    bindCardEvents() {
      this.cards.forEach((card, index) => {
        card.onmouseenter = () => this.onEnter(index);
        card.onfocus = () => this.onFocus(index);
      });
    }

    initCarousel() {
      if (this.cards.length === 0 || !this.track) return;

      this.activeIndex = Number.parseInt(this.dataset.defaultActive || '0', 10);
      if (Number.isNaN(this.activeIndex) || this.activeIndex < 0) this.activeIndex = 0;
      if (this.activeIndex >= this.cards.length) {
        this.activeIndex = Math.floor(this.cards.length / 2);
      }

      this.mq = window.matchMedia('(min-width: 990px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.boundOnMedia = this.onMediaChange.bind(this);
      this.boundOnResize = this.onResize.bind(this);
      this.boundOnScroll = this.onScroll.bind(this);
      this.boundOnScrollEnd = this.onScrollEnd.bind(this);
      this.mobileActiveIndex = 0;

      this.bindCardEvents();

      this.track.addEventListener('scroll', this.boundOnScroll, { passive: true });
      this.track.addEventListener('scrollend', this.boundOnScrollEnd);
      this.mq.addEventListener('change', this.boundOnMedia);
      window.addEventListener('resize', this.boundOnResize, { passive: true });

      this.ensureGsap().then(() => {
        if (!this.isConnected) return;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.applyLayout(true);
            this.updateMobilePaging();
            this.updateProgress();
          });
        });
      });
    }

    onMediaChange() {
      this.applyLayout(true);
    }

    onResize() {
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        this.applyLayout(true);
        this.updateMobilePaging();
        this.updateProgress();
      }, 100);
    }

    onScroll() {
      if (this.scrollRafId != null) return;
      this.scrollRafId = requestAnimationFrame(() => {
        this.scrollRafId = null;
        this.updateMobilePaging();
        this.updateProgress();
      });
    }

    onScrollEnd() {
      if (this.mq.matches) return;
      this.updateMobilePaging();
      this.updateProgress();
    }

    getMobileActiveIndex() {
      if (!this.track || this.cards.length === 0) return 0;

      const scrollLeft = this.track.scrollLeft;
      let activeIndex = 0;
      let minDistance = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    updateMobilePaging() {
      if (this.mq.matches) {
        this.cards.forEach((card) => card.classList.remove('is-mobile-active'));
        return;
      }

      const activeIndex = this.getMobileActiveIndex();
      this.mobileActiveIndex = activeIndex;

      this.cards.forEach((card, index) => {
        const isActive = index === activeIndex;
        card.classList.toggle('is-mobile-active', isActive);
        card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }

    updateProgress() {
      if (!this.track || !this.progressBar || !this.carousel) return;
      if (this.mq.matches) {
        this.carousel.classList.remove('is-scrollable');
        return;
      }

      const { scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      this.carousel.classList.toggle('is-scrollable', maxScroll > 4);

      const pageCount = this.cards.length;
      const activeIndex = this.mobileActiveIndex ?? this.getMobileActiveIndex();
      const progress = pageCount > 0 ? (activeIndex + 1) / pageCount : 1;
      this.progressBar.style.width = `${progress * 100}%`;
    }

    onEnter(index) {
      if (!this.mq.matches) return;
      this.setActive(index);
    }

    onFocus(index) {
      if (!this.mq.matches) return;
      this.setActive(index);
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.applyLayout(false);
    }

    ensureGsap() {
      if (window.gsap) return Promise.resolve(window.gsap);

      return new Promise((resolve) => {
        const start = Date.now();
        const tick = () => {
          if (window.gsap) {
            resolve(window.gsap);
            return;
          }
          if (Date.now() - start > 4000) {
            resolve(null);
            return;
          }
          requestAnimationFrame(tick);
        };
        tick();
      });
    }

    measurePanelWidths() {
      const count = this.cards.length;
      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const available = this.track.clientWidth - gap * Math.max(count - 1, 0);
      const totalGrow =
        ReviewHighlights.EXPANDED_GROW + ReviewHighlights.COLLAPSED_GROW * Math.max(count - 1, 0);

      if (available <= 0 || totalGrow <= 0) return;

      const expandedWidth = (available * ReviewHighlights.EXPANDED_GROW) / totalGrow;
      const collapsedWidth = (available * ReviewHighlights.COLLAPSED_GROW) / totalGrow;

      this.track.style.setProperty('--review-expanded-width', `${expandedWidth}px`);
      this.track.style.setProperty('--review-collapsed-width', `${collapsedWidth}px`);
    }

    clearDesktopStyles() {
      this.track.style.removeProperty('--review-expanded-width');
      this.track.style.removeProperty('--review-collapsed-width');

      this.cards.forEach((card) => {
        card.style.flexGrow = '';
        const collapsed = card.querySelector('[data-collapsed]');
        const expanded = card.querySelector('[data-expanded]');
        if (collapsed) {
          collapsed.style.opacity = '';
          collapsed.style.pointerEvents = '';
        }
        if (expanded) {
          expanded.style.opacity = '';
          expanded.style.pointerEvents = '';
        }
      });
    }

    applyLayout(immediate) {
      const desktop = this.mq.matches;
      const useMotion = !immediate && !this.reducedMotion.matches && window.gsap && desktop;

      this.cards.forEach((card, index) => {
        const collapsed = card.querySelector('[data-collapsed]');
        const expanded = card.querySelector('[data-expanded]');

        if (desktop) {
          const isActive = index === this.activeIndex;
          card.classList.toggle('is-expanded', isActive);
          card.classList.remove('is-mobile-active');
          card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          if (collapsed) collapsed.setAttribute('aria-hidden', isActive ? 'true' : 'false');
          if (expanded) expanded.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          return;
        }

        const isPageActive = index === (this.mobileActiveIndex ?? 0);
        card.classList.remove('is-expanded');
        card.classList.toggle('is-mobile-active', isPageActive);
        card.setAttribute('aria-expanded', isPageActive ? 'true' : 'false');
        if (collapsed) collapsed.setAttribute('aria-hidden', 'true');
        if (expanded) expanded.setAttribute('aria-hidden', 'false');
      });

      if (!desktop) {
        if (this.timeline) this.timeline.kill();
        this.clearDesktopStyles();
        this.updateMobilePaging();
        this.updateProgress();
        return;
      }

      this.measurePanelWidths();

      if (!useMotion) {
        this.cards.forEach((card, index) => {
          const isActive = index === this.activeIndex;
          const collapsed = card.querySelector('[data-collapsed]');
          const expanded = card.querySelector('[data-expanded]');
          card.style.flexGrow = isActive
            ? String(ReviewHighlights.EXPANDED_GROW)
            : String(ReviewHighlights.COLLAPSED_GROW);
          if (collapsed) {
            collapsed.style.opacity = isActive ? '0' : '1';
            collapsed.style.pointerEvents = isActive ? 'none' : 'auto';
          }
          if (expanded) {
            expanded.style.opacity = isActive ? '1' : '0';
            expanded.style.pointerEvents = isActive ? 'auto' : 'none';
          }
        });
        return;
      }

      if (this.timeline) this.timeline.kill();
      this.timeline = window.gsap.timeline({ defaults: { ease: 'power2.out' } });

      this.cards.forEach((card, index) => {
        const isActive = index === this.activeIndex;
        const collapsed = card.querySelector('[data-collapsed]');
        const expanded = card.querySelector('[data-expanded]');

        this.timeline.to(
          card,
          {
            flexGrow: isActive ? ReviewHighlights.EXPANDED_GROW : ReviewHighlights.COLLAPSED_GROW,
            duration: ReviewHighlights.DURATION,
          },
          0
        );

        if (collapsed) {
          this.timeline.to(
            collapsed,
            {
              opacity: isActive ? 0 : 1,
              duration: ReviewHighlights.FADE_DURATION,
              onStart: () => {
                collapsed.style.pointerEvents = isActive ? 'none' : 'auto';
              },
            },
            0
          );
        }

        if (expanded) {
          this.timeline.to(
            expanded,
            {
              opacity: isActive ? 1 : 0,
              duration: ReviewHighlights.FADE_DURATION,
              onStart: () => {
                if (!isActive) expanded.style.pointerEvents = 'none';
              },
              onComplete: () => {
                if (isActive) expanded.style.pointerEvents = 'auto';
              },
            },
            0
          );
        }
      });
    }
  }

  if (!customElements.get('review-highlights')) {
    customElements.define('review-highlights', ReviewHighlights);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  class VideoBanner extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.control = this.querySelector('[data-video-control]');
      if (!this.video || !this.control) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.boundToggle = this.toggle.bind(this);
      this.boundOnPlay = () => this.setPlaying(true);
      this.boundOnPause = () => this.setPlaying(false);
      this.boundOnMotionChange = this.onMotionChange.bind(this);

      this.control.addEventListener('click', this.boundToggle);
      this.video.addEventListener('play', this.boundOnPlay);
      this.video.addEventListener('pause', this.boundOnPause);
      this.reducedMotion.addEventListener('change', this.boundOnMotionChange);

      if (this.reducedMotion.matches) {
        this.video.pause();
        this.setPlaying(false);
      } else {
        this.setPlaying(!this.video.paused);
        const playPromise = this.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => this.setPlaying(false));
        }
      }
    }

    disconnectedCallback() {
      if (this.control) this.control.removeEventListener('click', this.boundToggle);
      if (this.video) {
        this.video.removeEventListener('play', this.boundOnPlay);
        this.video.removeEventListener('pause', this.boundOnPause);
      }
      if (this.reducedMotion) {
        this.reducedMotion.removeEventListener('change', this.boundOnMotionChange);
      }
    }

    onMotionChange() {
      if (!this.video) return;
      if (this.reducedMotion.matches) {
        this.video.pause();
      }
    }

    toggle() {
      if (!this.video) return;
      if (this.video.paused) {
        this.video.play().catch(() => this.setPlaying(false));
      } else {
        this.video.pause();
      }
    }

    setPlaying(isPlaying) {
      this.toggleAttribute('data-playing', isPlaying);
      if (!this.control) return;
      const label = isPlaying
        ? this.control.dataset.labelPause
        : this.control.dataset.labelPlay;
      if (label) this.control.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('video-banner')) {
    customElements.define('video-banner', VideoBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
